import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin');

var ALIGN_LEFT = "leftAlign",
  ALIGN_CENTER = "centerAlign";


var SvgChartLegend = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    id: "ChartLegend",
    legendItemId: "ChartLegendItem",
    barColor: "#C2C2C2",

    ALIGN_LEFT: ALIGN_LEFT,
    ALIGN_CENTER: ALIGN_CENTER
  },

  propTypes: {
    data: PropTypes.array.isRequired,
    itemWidth: PropTypes.number,
    itemHeight: PropTypes.number,
    onLegendItemClick: PropTypes.func,
    legendAlignment: PropTypes.string
  },

  getDefaultProps(){
    return {
      cols: 3,
      legendAlignment: ALIGN_LEFT
    };
  },

  render(){
    return (
      <g id={SvgChartLegend.id}>
        {this._getLegendItems()}
      </g>
    );
  },

  _getLegendItems(){
    var {data, itemWidth, itemHeight, box, legendAlignment, columnCount, fontSize} = this.props;
    var countItems = data.length,
      itemRelatedWidth = this.context.relativeX(itemWidth),
      x0 = this.context.relativeX(box[0]),
      y0 = this.context.relativeY(box[1]),
      width = this.context.relativeX(box[2]),
      height = this.context.relativeY(box[3]),
      cols = columnCount || Math.floor(width / itemRelatedWidth),
      rows = Math.ceil(countItems / cols),
      itemRelatedHeight = (height / rows) > this.context.relativeY(itemHeight)
        ? this.context.relativeY(itemHeight)
        : (height / rows),
      xPadding = 0,//(width - cols * itemRelatedWidth) / (cols + 1),
      lastRowCols = countItems - cols * (rows - 1);

    var items = [];

    fontSize = fontSize || itemRelatedHeight / 2;

    for (var i = 0; i < countItems; i++) {
      var rowNumber = Math.ceil((i + 1) / cols);

      if (rowNumber == rows && legendAlignment == SvgChartLegend.ALIGN_CENTER) {
        xPadding = (width - lastRowCols * itemRelatedWidth) / (lastRowCols + 1);
      }

      var colNumber = ((i + 1) % cols) ? (i + 1) % cols : cols,
        dx = colNumber * xPadding
          + (colNumber - 1) * itemRelatedWidth
          + x0,
        dy = (rowNumber - 1) * itemRelatedHeight + y0;

      var rectColor = data[i].color,
        textDecoration = data[i].disabled
          ? "line-through" : "none";

      items.push(
        <g key={i} className="legend-item"
           onClick={this.props.onLegendItemClick.bind(null, data[i].id)}>
          <rect
            x={0.05 * itemRelatedWidth + dx}
            y={1 / 3 * itemRelatedHeight + dy}
            width={0.15 * itemRelatedWidth}
            height={1 / 3 * itemRelatedHeight}
            fill={rectColor}
          />
          {this._getItemText(data[i].title, 0.22 * itemRelatedWidth + dx, 0.5 * itemRelatedHeight + dy, fontSize, textDecoration)}
        </g>
      )
    }

    return items;
  },

  _getItemText(text, x, y, fontSize, textDecoration){
    var words = text.split(" ");
    var len = 0, str1 = "", str2 = "";

    for (var i = 0; i < words.length; i++) {
      if (len + words[i].length + 1 > 25) {
        str2 += " " + words[i];
      } else {
        str1 += " " + words[i];
      }
      len += words[i].length + 1;
    }

    if (str2) {
      return [
        <text key="legend-text-1" x={x} y={y} textAnchor="start"
              dominantBaseline="text-after-edge" fontFamily={this.context.font}
              fontSize={fontSize} textDecoration={textDecoration}>
          {str1}
        </text>,
        <text key="legend-text-2" x={x} y={y} textAnchor="start"
              dominantBaseline="text-before-edge" fontFamily={this.context.font}
              fontSize={fontSize} textDecoration={textDecoration}>
          {str2}
        </text>
      ];
    }

    return (<text x={x} y={y} textAnchor="start" dominantBaseline="middle"
                  fontFamily={this.context.font} fontSize={fontSize}
                  textDecoration={textDecoration}>
      {text}
    </text>);
  }
});


module.exports = SvgChartLegend;
